// import { QuestionaryApiVersion, QuestionaryCore, QuestionaryCoreFromApi, QuestionnaireResponse, QuestionnaireResponseFromApi } from "../model/questionnaire-response";
import { MapKey } from 'src/app/shared/utils/type-functions';
import {
  QuestionaryApiVersion,
  QuestionaryCore,
  QuestionaryCoreFromApi,
  QuestionnaireResponse,
  QuestionnaireResponseFromApi,
} from '../model/questionnaire-response';

export const parseQuestionaryDate = <T extends QuestionaryCore>(item: QuestionaryApiVersion<T>): T =>
({
  ...item,
  questionnaireDate: item?.questionnaireDate ? new Date(item?.questionnaireDate) : null
} as T)


export const parseQuestionnariesFromApi = <T extends QuestionaryCore>(
  questionnary: QuestionnaireResponseFromApi<QuestionaryApiVersion<T>>
): QuestionnaireResponse<T> => {
  return {
    ...questionnary,
    myclinicHistory : (questionnary.myclinicHistory ?? []).map(parseQuestionaryDate),
    history: (questionnary.history ?? []).map(parseQuestionaryDate),
    lastQuestionnaire: questionnary.lastQuestionnaire ? parseQuestionaryDate(questionnary.lastQuestionnaire) : undefined,
    today: parseQuestionaryDate(questionnary.today)
  }
}
//       questionnaireDate: new Date(item.questionnaireDate),
//     } as T);
//   return {
//     ...questionnary,
//     history: (questionnary.history ?? []).map(parseToDate),
//     lastQuestionnaire: questionnary.lastQuestionnaire
//       ? parseToDate(questionnary.lastQuestionnaire)
//       : null,
//     today: parseToDate(questionnary.today),
//   };
// };
